import ReactQuill from 'react-quill';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import TextField from '@mui/material/TextField';

import styles from '../Form/Form.module.css';

export const LayoutQuestion = ({ children, ...props }) => {
  return (
    <div className={styles.top}>
      <div className={styles.question}>
        <div className={styles.input}>
          {props.type.id != 21 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '4px',
            }}
          >
            <p style={{ margin: 0, fontWeight: 'bold', marginRight: '8px' }}>
              {`Q${props.questions}`}
            </p>
            <p style={{ margin: 0 }}>Pregunta</p>
          </div>)}
          <ReactQuill
            theme="snow"
            value={props.information.name}
            onChange={(value) =>
              props.handleInformation({ target: { name: 'name', value } })
            }
            modules={props.quillModules}
            placeholder="Añadir pregunta aquí..."
            style={{
              backgroundColor: '#fff',
              borderRadius: '4px',
              marginBottom: '8px',
              border: props.errorMessage.name
                ? '1px solid #d32f2f'
                : '1px solid rgba(0,0,0,0.23)',
            }}
          />
          {props.errorMessage.name && (
            <span style={{ color: '#d32f2f', fontSize: '0.75rem' }}>
              {props.helperText.name}
            </span>
          )}
        </div>
      </div>
      {props.type.id != 21 && (
        <div className={styles.input}>
          <p>Descripción</p>
          <ReactQuill
            theme="snow"
            value={props.information.description}
          onChange={(value) =>
            props.handleInformation({ target: { name: 'description', value } })
          }
          modules={props.quillModules}
          placeholder="Añadir descripción aquí (opcional)..."
          style={{
            backgroundColor: '#fff',
            borderRadius: '4px',
            marginTop: '0.5rem',
            border: '1px solid rgba(0,0,0,0.23)',
            minHeight: '80px',
            width: '100%',
          }}
        />
      
      </div>)}
      {children}
    </div>
  );
};
